$(document).ready(() => {
    console.log('Document ready main menu');

    $('.hh-main-menu__item.hh-main-menu__item--parent').each((index, element) => {

        const currentSubmenuContainer = $(element).find('.hh-main-menu__sub-menu');
        const listSubMenu = currentSubmenuContainer.find('li');

        // Делаем элемент невидимым, но с сохранением геометрии, чтобы посчитать размеры
        currentSubmenuContainer.css({
            'display': 'flex',
            'visibility': 'hidden',
        });

        // Считаем ширину контейнера под-меню (чтобы правильно выставить размеры подложки)
        const subMenuWidth = listSubMenu.last().offset().left + listSubMenu.last().outerWidth() - listSubMenu.first().offset().left;

        // Меняем ширину контейнера на посчитанную
        currentSubmenuContainer.css('width', subMenuWidth);

        // Меняем обратно
        currentSubmenuContainer.css({
            'display': '',
            'visibility': '',
        });
    });
});

$('.hh-main-menu__item--parent .hh-main-menu__link').mouseenter((event) => {
    const currentSubmenuContainer = $(event.target).next();
    const listSubMenu = currentSubmenuContainer.find('li');

    // Считаем ширину контейнера под-меню (чтобы правильно выставить размеры подложки)
    const subMenuWidth = listSubMenu.last().offset().left + listSubMenu.last().outerWidth() - listSubMenu.first().offset().left;

    // Меняем ширину контейнера на посчитанную
    currentSubmenuContainer.css('width', subMenuWidth);
});

// Скрипт для мобильного меню
$('.hh-main-mobile-menu__item--parent .hh-main-mobile-menu__link').on('click', event => {
    event.preventDefault();

    const $submenu = $(event.target).next('.hh-main-mobile-menu__sub-menu');
    $submenu.show('fast');

    $submenu.prepend('<li class="hh-main-mobile-menu__sub-menu__item hh-main-mobile-menu__temp"><a href="' + $(event.target).attr('href') + '">Все статьи</a></li>');
    $submenu.prepend('<li class="hh-main-mobile-menu__sub-menu__item hh-main-mobile-menu__title-submenu hh-main-mobile-menu__temp">' + $(event.target).text() + '</li>');

    $submenu.before('<div class="hh-main-mobile-menu__overlay hh-main-mobile-menu__temp"></div>');

    $('.hh-main-mobile-menu__overlay').click(event => {
        $(event.target).hide('fast');
        $submenu.hide('fast');

        $('.hh-main-mobile-menu__temp').remove();
    });
});